import React, { useEffect, useState, memo } from 'react';
import { Check, Shield, AlertTriangle, Clock, Zap, Lock } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { PurchasePopup } from '../components/PurchasePopup';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQ } from '../components/FAQ';
export function SalesPage() {
  const productImageUrl = 'https://cdn.magicpatterns.com/uploads/6tbUPtXW8cGb1PWH4PqZsT/MOCKUPS_FILOSOFIA.png';
  const bonus1Url = 'https://cdn.magicpatterns.com/uploads/4aNtmiycKEziCmVRiCA2wb/bono_1_.png';
  const bonus2Url = 'https://cdn.magicpatterns.com/uploads/h85YjmrEH8ccfJ9S7EM1dx/bono_2_.png';
  const bonus3Url = 'https://cdn.magicpatterns.com/uploads/hdMfk4psySUTKCfZ2cf3MA/bono_3.png';
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 19 * 60 + 8);
  const [selectedPlan, setSelectedPlan] = useState<'basico' | 'completo' | 'premium'>('completo');
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTimeUnit = (value: number) => value.toString().padStart(2, '0');
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const scrollToPurchase = () => {
    const element = document.getElementById('purchase');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const getCheckoutUrl = () => {
    if (selectedPlan === 'basico') {
      return 'https://checkout.kitonline.shop/cart/47637808611566:1';
    }
    if (selectedPlan === 'premium') {
      return 'https://checkout.kitonline.shop/cart/47751669514478:1';
    }
    return 'https://checkout.kitonline.shop/cart/47664467968238:1';
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-31">
      <CountdownTimer data-id="element-32" />
      <PurchasePopup data-id="element-33" />

      {/* Hero Section */}
      <header className="bg-gradient-to-b from-gray-50 to-white py-3 md:py-5 px-3" data-id="element-34">
        <div className="max-w-5xl mx-auto text-center" data-id="element-35">
          <div className="inline-block bg-yellow-100 text-yellow-700 px-4 py-1 rounded-full font-bold text-xs mb-2 tracking-wider whitespace-nowrap" data-id="element-36">
            ⭐ El recurso #1 para docentes de Filosofía ⭐
          </div>

          <h1 className="text-xl md:text-4xl font-black text-gray-900 mb-1 leading-tight" data-id="element-37">
            Resolvé todo tu año de Filosofía en un solo lugar y dejá de
            planificar desde cero con el{' '}
            <span className="text-[#16a34a]" data-id="element-38">Kit Completo Filosofía Lista</span>
          </h1>

          <div className="cursor-pointer transform hover:scale-105 transition-transform duration-300 flex justify-center" onClick={scrollToPurchase} data-id="element-39">
            <img src="https://cdn.magicpatterns.com/uploads/aMR1dfTJmmyKistTR96xvC/MOCKUPSFILOSOFIA.png" alt="Kit Completo Filosofía Lista" className="w-full max-w-4xl drop-shadow-2xl" data-id="element-40" />
          </div>

          <p className="text-base md:text-lg text-gray-600 mb-3 max-w-3xl mx-auto" data-id="element-41">
            SISTEMA COMPLETO DE Clases claras y actividades, sin pasar horas
            planificando. Dejá de empezar desde cero cada semana.
          </p>

          <div className="flex items-center justify-center gap-2 mb-2 whitespace-nowrap" data-id="element-42">
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-gray-300 text-[10px] font-bold text-gray-600 bg-white" data-id="element-43">
              📄 100% PDF
            </span>
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-gray-300 text-[10px] font-bold text-gray-600 bg-white" data-id="element-44">
              ⚡ Acceso inmediato
            </span>
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full border border-gray-300 text-[10px] font-bold text-gray-600 bg-white" data-id="element-45">
              🇦🇷 Currículo argentino
            </span>
          </div>

          <CTAButton text="→ QUIERO MI KIT COMPLETO AHORA" className="w-full md:w-auto shadow-xl shadow-green-200 whitespace-nowrap" data-id="element-46" />

          <div className="flex items-center justify-center gap-3 mt-2 whitespace-nowrap text-[10px] font-bold text-gray-500" data-id="element-47">
            <span data-id="element-48">🟢 Garantía 7 días sin preguntas</span>
            <span data-id="element-49">🔒 Pago 100% seguro</span>
            <span data-id="element-50">💳 Mercado Pago</span>
          </div>
        </div>
      </header>

      {/* Problem Agitation */}
      <section className="py-6 md:py-8 bg-gray-50 px-3" data-id="element-51">
        <div className="max-w-3xl mx-auto" data-id="element-52">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-4" data-id="element-53">
            Si enseñás Filosofía, dejame hacerte una pregunta honesta
          </h2>

          <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border-l-4 border-[#dc2626]" data-id="element-54">
            <h3 className="text-xl font-bold text-[#dc2626] mb-2" data-id="element-55">
              ¿Te pasa que preparar la clase te cansa más que darla?
            </h3>
            <p className="text-base mb-2" data-id="element-56">
              No porque no sepas Filosofía. No porque no seas buen docente.
            </p>
            <p className="text-base font-bold mb-4" data-id="element-57">
              Sino porque cada clase parece empezar desde cero.
            </p>

            <ul className="space-y-2 mb-4" data-id="element-58">
              {['Buscar textos que se entiendan.', 'Pensar actividades que no aburran.', 'Armar consignas que hagan pensar.', 'Preparar evaluaciones sin caer en lo memorístico.', 'Adaptar contenidos abstractos al nivel real del aula.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-59">
                  <AlertTriangle className="w-4 h-4 text-orange-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-60" />
                  <span className="text-gray-700 text-sm" data-id="element-61">{item}</span>
                </li>)}
            </ul>

            <p className="text-sm italic text-gray-600 border-t pt-3" data-id="element-62">
              Y cuando finalmente entrás a clase… ya estás cansado/a.
            </p>
          </div>

          <div className="text-center mt-4" data-id="element-63">
            <h3 className="text-xl font-bold" data-id="element-64">
              👉 Enseñar Filosofía no debería sentirse así.
            </h3>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-6 md:py-8 bg-gray-900 text-white px-3" data-id="element-65">
        <div className="max-w-4xl mx-auto" data-id="element-66">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white" data-id="element-67">
            📘 ¿Qué incluye este Kit Completo?
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 items-start" data-id="element-68">
            <div className="space-y-5" data-id="element-69">
              <div data-id="element-70">
                <h3 className="text-lg font-bold text-yellow-400 mb-2" data-id="element-71">
                  1️⃣ Fundamentos de la Filosofía
                </h3>
                <ul className="space-y-1 ml-1" data-id="element-72">
                  {['Introducción al pensamiento filosófico', 'Mito y logos', 'Conocimiento y verdad', 'Alegoría de la Caverna'].map((item, i) => <li key={i} className="flex items-center" data-id="element-73">
                      <Check className="w-4 h-4 text-green-400 mr-2 flex-shrink-0" data-id="element-74" />
                      <span className="text-gray-200 text-sm" data-id="element-75">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div data-id="element-76">
                <h3 className="text-lg font-bold text-yellow-400 mb-2" data-id="element-77">
                  2️⃣ Historia y Problemas Filosóficos
                </h3>
                <ul className="space-y-1 ml-1" data-id="element-78">
                  {['Ética y moral', 'Filosofía política', 'Modernidad y sujeto', 'Alienación e ideología', 'Filosofía contemporánea'].map((item, i) => <li key={i} className="flex items-center" data-id="element-79">
                      <Check className="w-4 h-4 text-green-400 mr-2 flex-shrink-0" data-id="element-80" />
                      <span className="text-gray-200 text-sm" data-id="element-81">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div data-id="element-82">
                <h3 className="text-lg font-bold text-yellow-400 mb-2" data-id="element-83">
                  3️⃣ Recursos Didácticos para el Aula
                </h3>
                <ul className="space-y-1 ml-1" data-id="element-84">
                  {['Secuencias listas para usar', 'Actividades prácticas', 'Juegos y dinámicas', 'Set de cartas filosóficas', 'Banco de 100 ideas de actividades'].map((item, i) => <li key={i} className="flex items-center" data-id="element-85">
                      <Check className="w-4 h-4 text-green-400 mr-2 flex-shrink-0" data-id="element-86" />
                      <span className="text-gray-200 text-sm" data-id="element-87">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="space-y-5" data-id="element-88">
              <div data-id="element-89">
                <h3 className="text-lg font-bold text-yellow-400 mb-2" data-id="element-90">
                  4️⃣ Materiales Especiales
                </h3>
                <ul className="space-y-1 ml-1" data-id="element-91">
                  {['El Capital (con actividades)', 'Revistas docentes de Filosofía', 'Maletín de recursos complementarios'].map((item, i) => <li key={i} className="flex items-center" data-id="element-92">
                      <Check className="w-4 h-4 text-green-400 mr-2 flex-shrink-0" data-id="element-93" />
                      <span className="text-gray-200 text-sm" data-id="element-94">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div data-id="element-95">
                <h3 className="text-lg font-bold text-yellow-400 mb-2" data-id="element-96">
                  5️⃣ Planificación Anual 2026
                </h3>
                <ul className="space-y-1 ml-1" data-id="element-97">
                  {['Fundamentación', 'Contenidos organizados', 'Distribución trimestral', 'Criterios de evaluación'].map((item, i) => <li key={i} className="flex items-center" data-id="element-98">
                      <Check className="w-4 h-4 text-green-400 mr-2 flex-shrink-0" data-id="element-99" />
                      <span className="text-gray-200 text-sm" data-id="element-100">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          <div className="text-center mt-6" data-id="element-101">
            <p className="text-base text-gray-300" data-id="element-102">
              Todo organizado para encontrar rápido lo que necesitás y cubrir
              todo el programa.
            </p>
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-8 md:py-10 px-3 bg-[#0a0a0a]" data-id="element-103">
        <div className="max-w-5xl mx-auto" data-id="element-104">
          <div className="text-center mb-6" data-id="element-105">
            <h2 className="text-2xl md:text-4xl font-black text-white" data-id="element-106">
              Más los 3 Bonos{' '}
              <span className="italic text-[#22c55e]" data-id="element-107">Estratégicos</span>
            </h2>
            <p className="text-gray-400 mt-2 text-sm" data-id="element-108">
              Incluidos en todas las ofertas — sin costo extra
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-109">
            <div className="relative bg-[#141414] border border-[#2a2a2a] rounded-xl p-4 flex flex-col justify-between overflow-hidden" data-id="element-110">
              <div data-id="element-111">
                <span className="inline-block bg-[#16a34a] text-white text-[10px] font-bold uppercase tracking-widest px-2.5 py-0.5 rounded-full mb-2" data-id="element-112">
                  Bono #01
                </span>
                <span className="absolute top-3 right-4 text-[#22c55e] text-5xl font-black opacity-30 leading-none select-none" data-id="element-113">
                  01
                </span>
                <h3 className="text-white text-base font-bold mb-1 pr-10" data-id="element-114">
                  Kit Premium de Evaluaciones de Filosofía
                </h3>
                <p className="text-gray-400 text-xs leading-relaxed" data-id="element-115">
                  +50 evaluaciones listas con criterios de corrección.
                </p>
              </div>
              <div className="flex items-center justify-between mt-4" data-id="element-116">
                <p className="text-gray-500 text-xs line-through" data-id="element-117">
                  Valor $19.000
                </p>
                <span className="bg-[#16a34a] text-white text-[10px] font-bold px-3 py-1 rounded-full" data-id="element-118">
                  GRATIS
                </span>
              </div>
            </div>

            <div className="relative bg-[#141414] border border-[#2a2a2a] rounded-xl p-4 flex flex-col justify-between overflow-hidden" data-id="element-119">
              <div data-id="element-120">
                <span className="inline-block bg-[#16a34a] text-white text-[10px] font-bold uppercase tracking-widest px-2.5 py-0.5 rounded-full mb-2" data-id="element-121">
                  Bono #02
                </span>
                <span className="absolute top-3 right-4 text-[#22c55e] text-5xl font-black opacity-30 leading-none select-none" data-id="element-122">
                  02
                </span>
                <h3 className="text-white text-base font-bold mb-1 pr-10" data-id="element-123">
                  Banco de Juegos y Actividades Filosóficas
                </h3>
                <p className="text-gray-400 text-xs leading-relaxed" data-id="element-124">
                  Más de 30 recursos lúdicos para motivar tus clases.
                </p>
              </div>
              <div className="flex items-center justify-between mt-4" data-id="element-125">
                <p className="text-gray-500 text-xs line-through" data-id="element-126">
                  Valor $15.000
                </p>
                <span className="bg-[#16a34a] text-white text-[10px] font-bold px-3 py-1 rounded-full" data-id="element-127">
                  GRATIS
                </span>
              </div>
            </div>

            <div className="relative bg-[#141414] border border-[#2a2a2a] rounded-xl p-4 flex flex-col justify-between overflow-hidden" data-id="element-128">
              <div data-id="element-129">
                <span className="inline-block bg-[#16a34a] text-white text-[10px] font-bold uppercase tracking-widest px-2.5 py-0.5 rounded-full mb-2" data-id="element-130">
                  Bono #03
                </span>
                <span className="absolute top-3 right-4 text-[#22c55e] text-5xl font-black opacity-30 leading-none select-none" data-id="element-131">
                  03
                </span>
                <h3 className="text-white text-base font-bold mb-1 pr-10" data-id="element-132">
                  Plantillas Profesionales de Planificación
                </h3>
                <p className="text-gray-400 text-xs leading-relaxed" data-id="element-133">
                  Modelos semanales y mensuales para organizar todo el año.
                </p>
              </div>
              <div className="flex items-center justify-between mt-4" data-id="element-134">
                <p className="text-gray-500 text-xs line-through" data-id="element-135">
                  Valor $12.000
                </p>
                <span className="bg-[#16a34a] text-white text-[10px] font-bold px-3 py-1 rounded-full" data-id="element-136">
                  GRATIS
                </span>
              </div>
            </div>
          </div>

          <div className="mt-5 bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl py-3 px-4 text-center" data-id="element-137">
            <p className="text-base font-bold text-white" data-id="element-138">
              🎁 <span className="text-[#22c55e] font-black" data-id="element-139">BONOS GRATIS</span>{' '}
              — Solo por tiempo limitado
            </p>
            <p className="text-gray-400 text-xs mt-0.5" data-id="element-140">
              Incluidos en las 3 ofertas. Siempre.
            </p>
          </div>
        </div>
      </section>

      {/* Urgency Countdown Section */}
      <section className="py-8 md:py-10 px-3 bg-gradient-to-b from-[#1a0a0a] to-[#0a0a0a]" data-id="element-141">
        <div className="max-w-3xl mx-auto text-center" data-id="element-142">
          <h2 className="text-xl md:text-3xl font-black text-white mb-5 flex items-center justify-center gap-2" data-id="element-143">
            <span className="text-2xl" data-id="element-144">⏰</span>
            <span data-id="element-145">
              EL PRECIO DE LANZAMIENTO
              <br data-id="element-146" />
              TERMINA EN:
            </span>
          </h2>

          <div className="flex items-center justify-center gap-1 md:gap-3 mb-5" data-id="element-147">
            <div className="text-center" data-id="element-148">
              <span className="text-4xl md:text-7xl font-black text-[#ef4444]" data-id="element-149">
                {formatTimeUnit(hours)}
              </span>
              <p className="text-gray-400 text-[10px] mt-1 uppercase tracking-widest" data-id="element-150">
                HS
              </p>
            </div>
            <span className="text-4xl md:text-7xl font-black text-[#ef4444]" data-id="element-151">
              :
            </span>
            <div className="text-center" data-id="element-152">
              <span className="text-4xl md:text-7xl font-black text-[#ef4444]" data-id="element-153">
                {formatTimeUnit(minutes)}
              </span>
              <p className="text-gray-400 text-[10px] mt-1 uppercase tracking-widest" data-id="element-154">
                MIN
              </p>
            </div>
            <span className="text-4xl md:text-7xl font-black text-[#ef4444]" data-id="element-155">
              :
            </span>
            <div className="text-center" data-id="element-156">
              <span className="text-4xl md:text-7xl font-black text-[#ef4444]" data-id="element-157">
                {formatTimeUnit(seconds)}
              </span>
              <p className="text-gray-400 text-[10px] mt-1 uppercase tracking-widest" data-id="element-158">
                SEG
              </p>
            </div>
          </div>

          <p className="text-lg md:text-xl text-white mb-6" data-id="element-159">
            Después sube{' '}
            <span className="text-[#ef4444] font-black" data-id="element-160">$10.000 ARS</span> y no
            vuelve a bajar.
          </p>

          <div className="mb-5" data-id="element-161">
            <div className="flex items-center justify-between mb-1.5" data-id="element-162">
              <div className="flex items-center gap-1.5" data-id="element-163">
                <span className="w-2.5 h-2.5 bg-[#ef4444] rounded-full animate-pulse" data-id="element-164"></span>
                <span className="text-[#22c55e] text-xs font-medium" data-id="element-165">
                  Cupos al precio de lanzamiento
                </span>
              </div>
              <span className="text-white text-xs font-medium" data-id="element-166">
                Quedan pocos
              </span>
            </div>
            <div className="w-full h-2.5 bg-gray-700 rounded-full overflow-hidden" data-id="element-167">
              <div className="h-full bg-gradient-to-r from-[#22c55e] to-[#f97316] rounded-full" style={{
              width: '68%'
            }} data-id="element-168"></div>
            </div>
            <p className="text-gray-400 text-[10px] mt-1 text-right" data-id="element-169">
              68% de los cupos tomados
            </p>
          </div>

          <a href="#purchase" onClick={e => {
          e.preventDefault();
          scrollToPurchase();
        }} className="inline-flex items-center justify-center w-full max-w-md py-4 px-6 bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-lg uppercase tracking-wide rounded-xl transition-all duration-200 transform hover:scale-105 border-b-4 border-[#15803d]" data-id="element-170">
            → ASEGURAR MI PRECIO AHORA
          </a>
        </div>
      </section>

      {/* Pricing Selector Section */}
      <section id="purchase" className="py-8 md:py-10 px-3 bg-[#0a0a0a]" data-id="element-171">
        <div className="max-w-xl mx-auto" data-id="element-172">
          <div className="text-center mb-6" data-id="element-173">
            <h2 className="text-2xl md:text-3xl font-black text-white" data-id="element-174">
              Elegí tu <span className="text-[#22c55e]" data-id="element-175">KIT COMPLETO:</span>
            </h2>
            <p className="text-gray-400 mt-1 text-xs" data-id="element-176">
              Todas las opciones incluyen los 3 bonos estratégicos
            </p>
          </div>

          <div className="space-y-3 mb-5" data-id="element-177">
            <label className={`block cursor-pointer rounded-xl border-2 p-4 transition-all ${selectedPlan === 'basico' ? 'border-[#22c55e] bg-[#141414]' : 'border-[#2a2a2a] bg-[#0f0f0f] hover:border-[#3a3a3a]'}`} data-id="element-178">
              <div className="flex items-center justify-between" data-id="element-179">
                <div className="flex items-center gap-3" data-id="element-180">
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'basico' ? 'border-[#22c55e]' : 'border-gray-500'}`} data-id="element-181">
                    {selectedPlan === 'basico' && <div className="w-2 h-2 rounded-full bg-[#22c55e]" data-id="element-182"></div>}
                  </div>
                  <div data-id="element-183">
                    <div className="flex items-center gap-1.5" data-id="element-184">
                      <span className="text-yellow-400 text-sm" data-id="element-185">⚡</span>
                      <span className="text-white font-bold text-base" data-id="element-186">
                        FILOSOFÍA LISTA
                      </span>
                    </div>
                    <p className="text-gray-400 text-xs mt-0.5" data-id="element-187">
                      6 tomos de Filosofía + 3 bonos de regalo
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-188">
                  <p className="text-gray-500 text-xs line-through" data-id="element-189">$49.990</p>
                  <p className="text-[#22c55e] font-black text-xl" data-id="element-190">$19.990</p>
                </div>
              </div>
              <input type="radio" name="plan" value="basico" checked={selectedPlan === 'basico'} onChange={() => setSelectedPlan('basico')} className="sr-only" data-id="element-191" />
            </label>

            <label className={`block cursor-pointer rounded-xl border-2 p-4 transition-all ${selectedPlan === 'completo' ? 'border-[#22c55e] bg-[#141414]' : 'border-[#2a2a2a] bg-[#0f0f0f] hover:border-[#3a3a3a]'}`} data-id="element-192">
              <div className="flex items-center justify-between" data-id="element-193">
                <div className="flex items-center gap-3" data-id="element-194">
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'completo' ? 'border-[#22c55e]' : 'border-gray-500'}`} data-id="element-195">
                    {selectedPlan === 'completo' && <div className="w-2 h-2 rounded-full bg-[#22c55e]" data-id="element-196"></div>}
                  </div>
                  <div data-id="element-197">
                    <div className="flex items-center gap-1.5" data-id="element-198">
                      <span className="text-yellow-400 text-sm" data-id="element-199">🏆</span>
                      <span className="text-white font-bold text-base" data-id="element-200">
                        KIT COMPLETO
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 mt-0.5" data-id="element-201">
                      <span className="bg-[#22c55e] text-black text-[9px] font-bold px-1.5 py-0.5 rounded" data-id="element-202">
                        MÁS ELEGIDO
                      </span>
                      <span className="text-[#22c55e] text-[10px] font-bold" data-id="element-203">
                        AHORRÁS $9.990
                      </span>
                    </div>
                    <p className="text-gray-400 text-xs mt-0.5" data-id="element-204">
                      Kit completo + Evaluación 360° + bonos
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-205">
                  <p className="text-gray-500 text-xs line-through" data-id="element-206">$99.990</p>
                  <p className="text-[#22c55e] font-black text-xl" data-id="element-207">$26.990</p>
                </div>
              </div>
              <input type="radio" name="plan" value="completo" checked={selectedPlan === 'completo'} onChange={() => setSelectedPlan('completo')} className="sr-only" data-id="element-208" />
            </label>

            {/* Option 3 - Pack Premium */}
            <label className={`block cursor-pointer rounded-xl border-2 p-4 transition-all ${selectedPlan === 'premium' ? 'border-[#22c55e] bg-[#141414]' : 'border-[#2a2a2a] bg-[#0f0f0f] hover:border-[#3a3a3a]'}`} data-id="element-209">
              <div className="flex items-center justify-between" data-id="element-210">
                <div className="flex items-center gap-3" data-id="element-211">
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'premium' ? 'border-[#22c55e]' : 'border-gray-500'}`} data-id="element-212">
                    {selectedPlan === 'premium' && <div className="w-2 h-2 rounded-full bg-[#22c55e]" data-id="element-213"></div>}
                  </div>
                  <div data-id="element-214">
                    <div className="flex items-center gap-1.5" data-id="element-215">
                      <span className="text-yellow-400 text-sm" data-id="element-216">💎</span>
                      <span className="text-white font-bold text-base" data-id="element-217">
                        PACK PREMIUM
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 mt-0.5" data-id="element-218">
                      <span className="bg-yellow-400 text-black text-[9px] font-bold px-1.5 py-0.5 rounded" data-id="element-219">
                        MEJOR VALOR
                      </span>
                    </div>
                    <p className="text-gray-400 text-xs mt-0.5" data-id="element-220">
                      Filosofía Lista + Psicología Lista (6 tomos c/u) + bonos
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-221">
                  <p className="text-gray-500 text-xs line-through" data-id="element-222">$129.990</p>
                  <p className="text-[#22c55e] font-black text-xl" data-id="element-223">$32.990</p>
                </div>
              </div>
              <input type="radio" name="plan" value="premium" checked={selectedPlan === 'premium'} onChange={() => setSelectedPlan('premium')} className="sr-only" data-id="element-224" />
            </label>
          </div>

          <a href={getCheckoutUrl()} className="block w-full py-4 px-6 bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-lg text-center uppercase tracking-wide rounded-xl transition-all duration-200 transform hover:scale-105 border-b-4 border-[#15803d]" data-id="element-225">
            SÍ, QUIERO PACK COMPLETO →
          </a>

          <p className="text-gray-500 text-center text-xs mt-3 italic" data-id="element-226">
            La opción más elegida por docentes que enseñan Filosofía
          </p>

          <div className="mt-6 bg-[#141414] border border-[#2a2a2a] rounded-xl p-4" data-id="element-227">
            <h4 className="text-white font-bold text-xs uppercase tracking-wide mb-3" data-id="element-228">
              PACK COMPLETO INCLUYE:
            </h4>
            <div className="grid grid-cols-2 gap-2" data-id="element-229">
              {['Todos los materiales completos', '+50 clases con guión', 'Evaluaciones + rúbricas', 'Planificación anual 2026', '3 Bonos estratégicos', 'Acceso inmediato PDF'].map((item, i) => <div key={i} className="flex items-center gap-1.5" data-id="element-230">
                  <Check className="w-3.5 h-3.5 text-[#22c55e] flex-shrink-0" data-id="element-231" />
                  <span className="text-gray-300 text-xs" data-id="element-232">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="mt-5 flex items-center justify-center gap-3 flex-wrap text-gray-400 text-[10px]" data-id="element-233">
            <div className="flex items-center gap-1" data-id="element-234">
              <Lock className="w-3 h-3" data-id="element-235" />
              <span data-id="element-236">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-237">
              <Zap className="w-3 h-3" data-id="element-238" />
              <span data-id="element-239">Acceso en 5 min</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-240">
              <Shield className="w-3 h-3" data-id="element-241" />
              <span data-id="element-242">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-243">
              <span data-id="element-244">💳</span>
              <span data-id="element-245">Mercado Pago</span>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-6 md:py-8 px-3 bg-gray-50" data-id="element-246">
        <div className="max-w-3xl mx-auto text-center" data-id="element-247">
          <div className="inline-block p-3 rounded-full bg-white shadow-lg mb-3" data-id="element-248">
            <Shield className="w-12 h-12 text-blue-600" data-id="element-249" />
          </div>
          <h2 className="text-2xl font-bold mb-2" data-id="element-250">🛡️ Garantía sin riesgo</h2>
          <p className="text-base text-gray-600" data-id="element-251">
            Probalo durante 7 días. Si no es para vos, te devolvemos el 100% del
            dinero. Sin preguntas.
          </p>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-5 md:py-6 px-3" data-id="element-252">
        <div className="max-w-4xl mx-auto" data-id="element-253">
          <h2 className="text-lg font-bold text-center mb-3" data-id="element-254">
            💬 Lo que dicen otros docentes
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2" data-id="element-255">
            <TestimonialCard name="María G." role="Profesora de Filosofía, Buenos Aires" quote="Antes improvisaba mucho. Ahora entro a clase con todo listo." data-id="element-256" />
            <TestimonialCard name="Carlos R." role="Docente de Secundaria, Córdoba" quote="Me ahorra muchísimo tiempo. Las actividades realmente funcionan." data-id="element-257" />
            <TestimonialCard name="Ana M." role="Profesora de Filosofía, Rosario" quote="Mis alumnos participan más y yo explico con más seguridad." data-id="element-258" />
            <TestimonialCard name="Lucía T." role="Docente de Filosofía, Mendoza" quote="El material es claro y está muy bien organizado. Mis clases mejoraron notablemente." data-id="element-259" />
            <TestimonialCard name="Roberto S." role="Profesor de Secundaria, La Plata" quote="Finalmente puedo dedicar tiempo a enseñar en lugar de solo preparar." data-id="element-260" />
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-8 md:py-10 px-3 bg-[#0a0a0a]" data-id="element-261">
        <div className="max-w-3xl mx-auto" data-id="element-262">
          <h2 className="text-2xl md:text-3xl font-black text-center mb-6 text-white" data-id="element-263">
            ❓ Preguntas frecuentes
          </h2>
          <FAQ data-id="element-264" />
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-8 md:py-10 px-3 text-center" data-id="element-265">
        <div className="max-w-3xl mx-auto" data-id="element-266">
          <h2 className="text-2xl md:text-3xl font-black mb-3" data-id="element-267">
            Enseñar Filosofía puede ser más simple
          </h2>
          <p className="text-base text-gray-600 mb-5" data-id="element-268">
            No necesitás más material. Necesitás un sistema que te sostenga todo
            el año.
          </p>
        </div>
      </section>

      {/* Bottom Pricing Selector */}
      <section className="py-8 md:py-10 px-3 bg-[#0a0a0a]" data-id="element-269">
        <div className="max-w-xl mx-auto" data-id="element-270">
          <div className="text-center mb-6" data-id="element-271">
            <h2 className="text-2xl md:text-3xl font-black text-white" data-id="element-272">
              Elegí tu <span className="text-[#22c55e]" data-id="element-273">KIT COMPLETO:</span>
            </h2>
            <p className="text-gray-400 mt-1 text-xs" data-id="element-274">
              Todas las opciones incluyen los 3 bonos estratégicos
            </p>
          </div>

          <div className="space-y-3 mb-5" data-id="element-275">
            <label className={`block cursor-pointer rounded-xl border-2 p-4 transition-all ${selectedPlan === 'basico' ? 'border-[#22c55e] bg-[#141414]' : 'border-[#2a2a2a] bg-[#0f0f0f] hover:border-[#3a3a3a]'}`} data-id="element-276">
              <div className="flex items-center justify-between" data-id="element-277">
                <div className="flex items-center gap-3" data-id="element-278">
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'basico' ? 'border-[#22c55e]' : 'border-gray-500'}`} data-id="element-279">
                    {selectedPlan === 'basico' && <div className="w-2 h-2 rounded-full bg-[#22c55e]" data-id="element-280"></div>}
                  </div>
                  <div data-id="element-281">
                    <div className="flex items-center gap-1.5" data-id="element-282">
                      <span className="text-yellow-400 text-sm" data-id="element-283">⚡</span>
                      <span className="text-white font-bold text-base" data-id="element-284">
                        FILOSOFÍA LISTA
                      </span>
                    </div>
                    <p className="text-gray-400 text-xs mt-0.5" data-id="element-285">
                      6 tomos de Filosofía + 3 bonos de regalo
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-286">
                  <p className="text-gray-500 text-xs line-through" data-id="element-287">$49.990</p>
                  <p className="text-[#22c55e] font-black text-xl" data-id="element-288">$19.990</p>
                </div>
              </div>
              <input type="radio" name="plan2" value="basico" checked={selectedPlan === 'basico'} onChange={() => setSelectedPlan('basico')} className="sr-only" data-id="element-289" />
            </label>

            <label className={`block cursor-pointer rounded-xl border-2 p-4 transition-all ${selectedPlan === 'completo' ? 'border-[#22c55e] bg-[#141414]' : 'border-[#2a2a2a] bg-[#0f0f0f] hover:border-[#3a3a3a]'}`} data-id="element-290">
              <div className="flex items-center justify-between" data-id="element-291">
                <div className="flex items-center gap-3" data-id="element-292">
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'completo' ? 'border-[#22c55e]' : 'border-gray-500'}`} data-id="element-293">
                    {selectedPlan === 'completo' && <div className="w-2 h-2 rounded-full bg-[#22c55e]" data-id="element-294"></div>}
                  </div>
                  <div data-id="element-295">
                    <div className="flex items-center gap-1.5" data-id="element-296">
                      <span className="text-yellow-400 text-sm" data-id="element-297">🏆</span>
                      <span className="text-white font-bold text-base" data-id="element-298">
                        KIT COMPLETO
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 mt-0.5" data-id="element-299">
                      <span className="bg-[#22c55e] text-black text-[9px] font-bold px-1.5 py-0.5 rounded" data-id="element-300">
                        MÁS ELEGIDO
                      </span>
                      <span className="text-[#22c55e] text-[10px] font-bold" data-id="element-301">
                        AHORRÁS $9.990
                      </span>
                    </div>
                    <p className="text-gray-400 text-xs mt-0.5" data-id="element-302">
                      Kit completo + Evaluación 360° + bonos
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-303">
                  <p className="text-gray-500 text-xs line-through" data-id="element-304">$99.990</p>
                  <p className="text-[#22c55e] font-black text-xl" data-id="element-305">$26.990</p>
                </div>
              </div>
              <input type="radio" name="plan2" value="completo" checked={selectedPlan === 'completo'} onChange={() => setSelectedPlan('completo')} className="sr-only" data-id="element-306" />
            </label>

            <label className={`block cursor-pointer rounded-xl border-2 p-4 transition-all ${selectedPlan === 'premium' ? 'border-[#22c55e] bg-[#141414]' : 'border-[#2a2a2a] bg-[#0f0f0f] hover:border-[#3a3a3a]'}`} data-id="element-307">
              <div className="flex items-center justify-between" data-id="element-308">
                <div className="flex items-center gap-3" data-id="element-309">
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'premium' ? 'border-[#22c55e]' : 'border-gray-500'}`} data-id="element-310">
                    {selectedPlan === 'premium' && <div className="w-2 h-2 rounded-full bg-[#22c55e]" data-id="element-311"></div>}
                  </div>
                  <div data-id="element-312">
                    <div className="flex items-center gap-1.5" data-id="element-313">
                      <span className="text-yellow-400 text-sm" data-id="element-314">💎</span>
                      <span className="text-white font-bold text-base" data-id="element-315">
                        PACK PREMIUM
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5 mt-0.5" data-id="element-316">
                      <span className="bg-yellow-400 text-black text-[9px] font-bold px-1.5 py-0.5 rounded" data-id="element-317">
                        MEJOR VALOR
                      </span>
                    </div>
                    <p className="text-gray-400 text-xs mt-0.5" data-id="element-318">
                      Filosofía Lista + Psicología Lista (6 tomos c/u) + bonos
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-319">
                  <p className="text-gray-500 text-xs line-through" data-id="element-320">$129.990</p>
                  <p className="text-[#22c55e] font-black text-xl" data-id="element-321">$32.990</p>
                </div>
              </div>
              <input type="radio" name="plan2" value="premium" checked={selectedPlan === 'premium'} onChange={() => setSelectedPlan('premium')} className="sr-only" data-id="element-322" />
            </label>
          </div>

          <a href={getCheckoutUrl()} className="block w-full py-4 px-6 bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-lg text-center uppercase tracking-wide rounded-xl transition-all duration-200 transform hover:scale-105 border-b-4 border-[#15803d]" data-id="element-323">
            SÍ, QUIERO PACK COMPLETO →
          </a>

          <p className="text-gray-500 text-center text-xs mt-3 italic" data-id="element-324">
            La opción más elegida por docentes que enseñan Filosofía
          </p>
        </div>
      </section>

      <footer className="bg-gray-900 text-gray-400 py-4 text-center text-xs" data-id="element-325">
        <p data-id="element-326">
          © {new Date().getFullYear()} Kit Completo Filosofía Lista. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}